import { render } from "./ItemSelect.vue?vue&type=template&id=bfd9358e&scoped=true"
import script from "./ItemSelect.vue?vue&type=script&lang=js"
export * from "./ItemSelect.vue?vue&type=script&lang=js"

import "./ItemSelect.vue?vue&type=style&index=0&id=bfd9358e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd9358e"]])

export default __exports__